import React, { useState, useEffect } from 'react';
import { historiqueService } from '../services/historiqueService';
import ProgrammeConference from './ProgrammeConference';
import MediaPreview from './MediaPreview';
import APropos from './APropos';
import Speakers from './Speakers';
import CongressTopics from './CongressTopics';
import CongressObjectives from './CongressObjectives';
import CongressDates from './CongressDates';
import GSIDAAcademicChallenge from './GSIDAAcademicChallenge';
import NosFlyers from './NosFlyers';
import Contact from './Contact';
import { supabase } from '../supabaseClient';
import './Historique.css';

function Historique({ edition }) {
  const [currentEdition, setCurrentEdition] = useState(edition);
  const [editionData, setEditionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadEditionData();
  }, [edition]);

  const loadEditionData = async () => {
    try {
      setLoading(true);
      let targetEdition = edition;

      // If no edition is provided, fetch the most recent inactive one
      if (!targetEdition) {
        const { data: latestInactive } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', false)
          .order('year', { ascending: false })
          .limit(1)
          .single();
        
        targetEdition = latestInactive?.year || '2025';
      }

      setCurrentEdition(targetEdition);
      const data = await historiqueService.getHistoriqueData(targetEdition);
      setEditionData(data);
      setError(null);
    } catch (error) {
      console.error('Error loading edition data:', error);
      setError('Erreur lors du chargement des données de l\'édition.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="historique-page loading">
        <div className="loading-spinner"></div>
        <p>Chargement de l'édition {currentEdition || edition}...</p>
      </div>
    );
  }

  if (error || !editionData) {
    return (
      <div className="historique-page error">
        <h1>Édition {currentEdition || edition}</h1>
        <p>Aucune donnée disponible pour cette édition.</p>
      </div>
    );
  }

  return (
      <div className="historique-page">
        {/* Statistics Header (Replaces Hero) */}
        <div className="historique-hero-stats">
          <div className="stats-header-content">
            <h1>Édition {currentEdition}</h1>
            <h2 className="stats-theme">{editionData.theme}</h2>
            
            <div className="stats-grid-hero">
              <div className="stat-card">
                <span className="stat-number">{editionData.stats.participants || '0'}</span>
                <span className="stat-label">Participants</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">{editionData.stats.conferences || '0'}</span>
                <span className="stat-label">Conférences</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">{editionData.stats.speakers || '0'}</span>
                <span className="stat-label">Intervenants</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">{editionData.stats.topics || '0'}</span>
                <span className="stat-label">Axes de Recherche</span>
              </div>
            </div>

            <div className="hero-edition-info">
               <p><strong>Lieu:</strong> {editionData.lieu}</p>
               <p><strong>Date:</strong> {editionData.date}</p>
            </div>
          </div>
        </div>

        {/* Page Sections (Same as Home) */}
        <ProgrammeConference edition={currentEdition} />
        <MediaPreview edition={currentEdition} />
        <APropos edition={currentEdition} />
        <Speakers edition={currentEdition} />
        <CongressTopics edition={currentEdition} />
        <CongressObjectives edition={currentEdition} />
        <CongressDates edition={currentEdition} />
        <GSIDAAcademicChallenge edition={currentEdition} />
        <NosFlyers edition={currentEdition} />
        <Contact edition={currentEdition} />
      </div>
  );
}

export default Historique;
